import React from 'react';
import Navbar from '../../components/Navbar/Navbar';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import DownloadIcon from '@mui/icons-material/Download';
import './Homepage.scss'

const Homepage = () => {
  return (
    <div className="homepage homepage__container">
      <Navbar />
        <div className="hero">
            <div className="hero__bg">
                <div className="hero__main">
                    <div className="hero__main--text">
                        <div className="hero__main--text-welcome">
                            Welcome to
                        </div>
                        <div className="hero__main--text-main">
                            Pneuma Life <br/>
                            City Church
                        </div>
                        <div className="hero__main--btn">
                            <div>
                                <button className="btn icon-btn btn--primary">
                                    <PlayArrowIcon />
                                    <span>Latest Sermon</span>
                                </button>
                            </div>
                            <div>
                                <button className="btn icon-btn text-btn btn-second">
                                    <DownloadIcon />
                                    <span>Downlaod Photizo</span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="hero__activities">
                        <div className="hero__activities--head">
                            Service Days
                        </div>
                        <div className="hero__activities--text">
                            <div className="hero__activities--text-item">
                                Sunday - 9am
                            </div>
                            <div className="hero__activities--text-item">
                                Wednesday - 5pm
                            </div>
                            <div className="hero__activities--text-item">
                                Saturday (Love circle) - 5pm
                            </div>
                        </div>
                    </div>
                </div>



            </div>
        </div>
    </div>
  )
}

export default Homepage
